//@flow
import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled, {css} from 'styled-components';
import { rgba } from 'polished';
import { find } from 'lodash';
import { Link } from 'react-router-dom'
import { Timeline } from 'react-twitter-widgets'
import Helmet from 'react-helmet'
import moment from 'moment'
import ReactBodymovin from 'react-bodymovin'
import animation from '../Home/animation.json'
import Fade from 'react-reveal/Fade';

import { fetchPage, getPages } from '../Page/redux';

import logo from 'svg-react-loader?name=Icon!../../assets/images/nav-logo.svg';

import { paleGreen } from '../../styles/colors';
import { hoverState, body, padding } from '../../styles/global';
import { media } from '../../styles/utils';
import MetaTags from '../../components/MetaTags/MetaTags.js';

type Props = {}

type State = {}

class Contact extends Component<Props, State> {

    state = {
        twitterLoaded: false
    }

    componentWillMount() {
        this.props.fetchPage('contact');
    }

    render() {
        const { twitterLoaded } = this.state;
        const { pages } = this.props;

        const pageData = find(pages, (o) => { return o.slug == 'contact' })

        console.log(pageData)

        return (
            <Container>

                {pageData && (
                    <Fade
                        up
                        duration={1000}
                        distance={'50px'}
                    >
                        <Info>
                            <Heading>Contact</Heading>

                            <MetaTags
                                title={'Contact'}
                                description={pageData.text}
                            />

                            {pageData && (
                                <Content
                                    dangerouslySetInnerHTML={{__html: pageData.text}}
                                />
                            )}

                            {pageData && pageData.twitter_or_buttons == 'buttons' && (
                                <DownloadButtons>

                                    <Button
                                        href={pageData.button_1_download_link}
                                    >
                                        {pageData.button_1_text}
                                    </Button>

                                    <Button
                                        href={pageData.button_2_download_link}
                                    >
                                        {pageData.button_2_text}
                                    </Button>

                                </DownloadButtons>
                            )}

                            <ContactInfo>
                        
                                <EmailLink
                                    href={`mailto:${'hello@orlose.it'}`}
                                >
                                    hello@orlose.it
                                </EmailLink>

                                <CCL
                                    dangerouslySetInnerHTML={{__html: `
                                        <a rel="license" href="http://creativecommons.org/licenses/by-nc/4.0/" target="_blank">
                                            <img alt="Creative Commons License" style="border-width:0" src="https://i.creativecommons.org/l/by-nc/4.0/88x31.png" />
                                        </a>
                                    `}}
                                />

                            </ContactInfo>
                        </Info>
                    </Fade>

                )}

                {pageData && (           
                    <RightSide>
                        <Logo>
                            <ReactBodymovin 
                                options={{
                                    loop: true,
                                    autoplay: true,
                                    prerender: true,
                                    animationData: animation
                                }} 
                            />
                       </Logo>
                    </RightSide>
                )}

                {/* {pageData && pageData.twitter_or_buttons == 'twitter' && (
                    <TwitterFeed>
                        <TimelineWrapper
                            visible={twitterLoaded}
                        >
                            <Timeline
                                dataSource={{
                                    sourceType: 'profile',
                                    screenName: pageData.twitter_handle
                                }}
                                options={{
                                    username: pageData.twitter_handle,
                                    height: '600'
                                }}
                                onLoad={() => this.setState({twitterLoaded: true})}
                            />
                        </TimelineWrapper>
                    </TwitterFeed>
                )} */}



            </Container>
        )
    }
}

const section = css`
    flex: 0 1 50%;
`


const Container = styled.div`
    display: flex;
    background: white;
    min-height: 100vh;

    ${media.tablet`
        flex-direction: column;
    `}

    .react-reveal {
        ${section}
    }
`;

const Heading = styled.div``;
const Content = styled.div``;

// Info

const Info = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 70px;

    ${Heading} {
        font-family: Platform-Medium;
        font-size: 32px;
        color: #4D4D4D;
        letter-spacing: 0.19px;
        margin-bottom: 38px;
    }

    ${Content} {
        p {
            ${body}
        }

        max-width: 500px;
        margin-bottom: 48px;
    }

    ${media.tablet`
        padding-bottom: 48px;
        align-items: center;
        text-align: center;
    `}

    ${media.phone`
        padding: 64px 32px 48px;
        align-items: center;
        text-align: center;
    `}
`



const EmailLink = styled.a`
    ${hoverState}
    font-family: Platform-Medium;
    font-size: 23px;
    color: #BABABA;
    letter-spacing: 0.14px;
`

const CCL = styled.div`
    padding-left: 40px;
    ${media.tablet`
       padding: 0;
       margin-top: 20px;
    `}
`

const ContactInfo = styled.div`
    display: flex;
    justify-content: left;
    align-items: left;

    ${media.tablet`
        flex-direction: column;
    `}

`

const RightSide = styled.div`
    ${section};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 70px;

    ${media.tablet`
        padding-top: 0;
        margin-bottom: 48px;
    `}

    ${media.phone`
        padding: 0 32px;
        margin-bottom: 96px;
    `}

`


const Logo = styled.div`
    max-width: 512px;
    max-height: 512px;
    margin-bottom: 115px;
`



// Twitter Feed

const TwitterFeed = styled.div`
    ${section}
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 70px;

    ${media.tablet`
        padding-top: 0;
        margin-bottom: 48px;
    `}

    ${media.phone`
        padding: 0 32px;
        margin-bottom: 96px;
    `}
`;

const TimelineWrapper = styled.div`
    background: #FFFFFF;
    border: 1px solid #EDEDED;
    box-shadow: 0 2px 4px 0 rgba(119,119,119,0.10);
    border-radius: 4px;

    /* Display toggle */
    
    transition: opacity 0.25s ease;
    opacity: ${props => props.visible ? 1 : 0};
`;

// Download Buttons

const DownloadButtons = styled.div`
    /* ${section} */
    display: flex;
    justify-content: left;
    align-items: left;
    margin-bottom: 60px;

    ${media.tablet`
        flex-direction: column;
        /* padding-bottom: 128px; */
    `}
`

const Button = styled.a`
    display: flex;
    justify-content: center;
    align-items: center;

    background: rgba(0,0,0,0.1);
    box-shadow: 0 2px 1px 0 rgba(0,0,0,0.02);
    border-radius: 8px;

    width: 182px;
    height: 52px;

    font-family: 'Platform-Regular';
    font-size: 14px;
    color: #4D4D4D;
    letter-spacing: 1.28px;
    text-align: center;
    line-height: 9px;    

    transition: all 0.1s ease;

    &:hover {
        color: white;
        background: #DB5537;
        box-shadow: 0 2px 1px 0 rgba(0,0,0,0);
    }

    &:nth-child(2){
        &:hover {
            background: #9A66FE;
        }
    }

    &:not(:last-child) {
        margin-right: 28px;

        ${media.tablet`
            margin-right: 0;
            margin-bottom: 18px;
        `}
    }
`






const mapDispatchToProps = dispatch => ({
    fetchPage(slug) {
        dispatch(fetchPage(slug))
    }
})

const mapStateToProps = (state, props) => ({
    pages: getPages(state)
})

export default connect(mapStateToProps, mapDispatchToProps)(Contact);



// WEBPACK FOOTER //
// ./client/modules/Contact/Contact.js